
const FilterAray = [
    {
        id: 1,
        CardImg: require("../../img/card-img1.png"),
        TagText: "Best Rated",
        CardHeading: "Women",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 2,
        CardImg: require("../../img/card-img2.png"),
        TagText: "Best Rated",
        CardHeading: "Men",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 3,
        CardImg: require("../../img/card-img3.png"),
        TagText: "Best Rated",
        CardHeading: "Baby",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 4,
        CardImg: require("../../img/card-img4.png"),
        TagText: "Best Rated",
        CardHeading: "Girl",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 5,
        CardImg: require("../../img/card-img5.png"),
        TagText: "Best Rated",
        CardHeading: "Boy",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 6,
        CardImg: require("../../img/card-img6.png"),
        TagText: "Best Rated",
        CardHeading: "Women Shirt",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 7,
        CardImg: require("../../img/card-img7.png"),
        TagText: "Best Rated",
        CardHeading: "Women Shirt",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 8,
        CardImg: require("../../img/card-img8.png"),
        TagText: "Best Rated",
        CardHeading: "Women Shirt",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    }
]

export default FilterAray